import { useContext, useEffect, useMemo } from "react";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useProducerListAction from "../actions/list/useProducerListAction";
import { Card } from "react-bootstrap";
import useExportAction from "../actions/export/useExportAction";
import { HandCoins } from "@phosphor-icons/react";
import { ListActionContext } from "../actions/list/ListActionContext";

function ProducerBalancesPage() {
  const { user } = useContext(AuthContext);
  const { setTableFilters } = useContext(ListActionContext);

  // Filtros específicos para el productor actual.
  // status: "pending" -> al cargar, muestra por defecto solo las liquidaciones pendientes.
  const producerFilters = useMemo(() => {
    if (user?.producer?.id) {
      return {
        emitter_id: user.producer.id,
        emitter_type: "App\\Models\\Producer",
        status: "pending",
      };
    }
    return {};
  }, [user?.producer?.id]);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useProducerListAction(user);

  const { exportFunction, actionTemplate: exportActionTemplate } =
    useExportAction(producerFilters);

  /**
   * Table configuration simplificada para productores
   */
  const memoTableConfig = useMemo(
    () => ({
      index: indexFunction,
      actions: [
        {
          name: "EXPORT",
          label: "export",
          allowed: true,
          show: true,
          action: exportFunction,
          icon: <HandCoins size={20} />,
        },
      ],
      rowActions: [],
      rowConfiguration: {},
      columns: [],
      pagination: {
        enabled: true,
        back: true,
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    setTableConfig(memoTableConfig);
  }, [memoTableConfig, setTableConfig]);

  // Aplicar filtros del productor automáticamente
  useEffect(() => {
    if (Object.keys(producerFilters).length > 0) {
      setTableFilters(producerFilters);
    }
  }, [producerFilters, setTableFilters]);

  return (
    <Card>
      <Card.Header>
        <Card.Title>
          <HandCoins size={24} /> {t("my_balances")}
        </Card.Title>
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {exportActionTemplate}
      </Card.Body>
    </Card>
  );
}

export default ProducerBalancesPage;
